import { colors, fonts, radius } from '../../theme';

const textField = {
  width: '100%',
};

const styles = {
  textField,
  // Dark TextField of the connected pages and the auth pages, same as CustomInput.
  textFieldDark: {
    ...textField,
    '& .MuiOutlinedInput-root': {
      backgroundColor: colors.background,
      color: colors.text,
      borderRadius: radius.input,
      fontFamily: fonts.text,
      fontSize: 14,
      '& fieldset': {
        borderColor: colors.border,
      },
      '&:hover fieldset': {
        borderColor: colors.borderHover,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.borderFocus,
        borderWidth: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: colors.textSecondary,
      fontFamily: fonts.text,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: colors.text,
    },
    '& .MuiInputBase-input::placeholder': {
      color: colors.textSubtle,
      opacity: 1,
    },
  },
};

export default styles;
